module.exports = __webpack_public_path__ + "static/media/arrow-down-new.2f93d646.svg";